import { Link } from 'react-router-dom';
import './AuthLayout.css';

const AuthLayout = ({ children, title }) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="page-container">
      <div className="main-content">
        <div className="content-wrapper">
          {/* Left Column - Branding */}
          <div className="brand-section">
            <div className="brand-content">
              <img 
                src="https://cdn.shopify.com/s/files/1/0438/8087/4152/files/Art_Emerge_Logo_copy.png?v=1744657283" 
                alt="Art Emerge" 
                className="logo" 
              />
              <h2 className="brand-tagline">
                Connect with artists, galleries, and collectors in the world's most innovative art marketplace.
              </h2>
            </div>
          </div>

          {/* Right Column - Auth Form */}
          <div className="form-section">
            <div className="form-wrapper">
              <div className="form-card">
                <h1 className="title">{title}</h1>
                {children}
              </div>
              <p className="signup-text">
                {title === "Welcome back" 
                  ? "Don't have an account? "
                  : "Already have an account? "}
                <Link 
                  to={title === "Welcome back" ? "/signup" : "/login"}
                  className="signup-link"
                >
                  {title === "Welcome back" ? "Sign up" : "Login"}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-links">
            <Link to="/terms" className="footer-link">Terms</Link>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </div>
          <div className="copyright">
            © {currentYear} Art Emerge. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout; 